

import {
  Component,
  OnInit,
} from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { NGXLogger } from "ngx-logger";
import { ConfirmationService, MenuItem, MessageService } from "primeng/api";

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Subject } from "rxjs";
import { Bando } from "src/app/models/bando.model";
import { Impresa } from "src/app/models/impresa.model";
import { Listino } from "src/app/models/listino.model";
import { Oda } from "src/app/models/oda.model";
import { ImpreseService } from "src/app/services/imprese.service";
import { ListiniService } from "src/app/services/listini.service";
import { OdaService } from "src/app/services/oda.service";


@Component({
  templateUrl: "./dialog-modifica-oda.component.html",
  styleUrls: ["../oda.component.css"],
  providers: [MessageService]
})
export class ModificaOdaComponent implements OnInit {
  protected _onDestroy              = new Subject<void>();
  protected odaDaModificare:Oda;
  protected bandi:Bando[] = [];
  protected lotti:String[];

  public modificaOdaForm: FormGroup;

  protected isUpdatingOda:Boolean = false;

  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private impreseService: ImpreseService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private _formBuilder: FormBuilder,
    private odaService:OdaService,
  ) {
    let bando1:Bando = new Bando();
    bando1.denominazione = "BANDO 1";
    bando1.id = 1;
    let bando2:Bando = new Bando();
    bando2.denominazione = "BANDO 2";
    bando2.id = 2;
    this.bandi.push(bando1);
    this.bandi.push(bando2);
    this.odaDaModificare = this.config.data.oda;
    this.modificaOdaForm = this._formBuilder.group({
      //bando:                     new FormControl({value: this.odaDaModificare.bando, disabled: false}, Validators.required),
      //lotti:                      new FormControl({value: this.odaDaModificare.lotti, disabled: true}, Validators.required),
      referenteTim:               [this.odaDaModificare.referenteTim, [Validators.required]],
      numero:                     [this.odaDaModificare.numero, [Validators.required]],
      importo:                    [this.odaDaModificare.importo, [Validators.required]]
    });

  }

  ngOnInit(): void {
    
    
  }

  onBandoSelection(event){
    this.logger.info( this.modificaOdaForm.value.bando);

    if(this.modificaOdaForm.value.bando.denominazione ==='BANDO 1'){
      this.lotti = ['5','6'];
    }else{
      this.lotti = ['1','5','7','8'];
    }
    
    this.modificaOdaForm.get("lotti").enable();
  }

  checkNumero(event){
    this.odaService.checkNumero(this.modificaOdaForm.value.numero).subscribe( {
      next: (ressCheckNumero) => {
        if(ressCheckNumero){
          this.messageService.add({ severity: 'warn', summary: 'ATTENZIONE', detail: 'Il numero indicato è già presente a sistema' });
          this.modificaOdaForm.controls['numero'].setErrors({ 'duplicato': true });
          } else {
              // Rimuovi eventuali errori precedenti (se il numero non è duplicato)
              this.modificaOdaForm.controls['numero'].setErrors(null);
          }
      },
      error: (e) => {
          this.isUpdatingOda = false;
          this.logger.error(e);
          this.dialogRef.close({ success: false });
          this.messageService.add({
            severity: "error",
            summary: "ATTENZIONE",
            detail: "Errore in fase di check numero ODA!", life:10000
          });
      },
      complete: () => {

      }
    });
  }
  
  

  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      this.isUpdatingOda = true;
      //let oda:Oda = new Oda();
        this.odaDaModificare.numero              = this.modificaOdaForm.value.numero;
        this.odaDaModificare.importo             = this.modificaOdaForm.value.importo;
        this.odaDaModificare.bando               = this.modificaOdaForm.value.bando;
        this.odaDaModificare.lotti               = this.modificaOdaForm.value.lotti;
        this.odaDaModificare.referenteTim        = this.modificaOdaForm.value.referenteTim;
        this.odaService.modifica(this.odaDaModificare).subscribe( {
            next: (resModificaOda) => {
              this.isUpdatingOda = false;
              this.dialogRef.close({ success: true });
            },
            error: (e) => {
                this.isUpdatingOda = false;
                this.logger.error(e);
                this.dialogRef.close({ success: false });
                this.messageService.add({
                  severity: "error",
                  summary: "ATTENZIONE",
                  detail: "Errore in fase di modifica dell'oda!", life:10000
                });
            },
            complete: () => {

            }
        });  
    }
  }
}
